import React from "react";
import { FaTv } from "react-icons/fa6";
import logo from "../../images/logo.jpg";

import { Link } from "react-router-dom";

const Sidebar = () => {
  return (
    <div className="bg-white p-3">
      <Link to={"/"} className="navbar-brand">
        <img src={logo} width={160} className="object-fit-contain" alt="" />
      </Link>
      <Link
        to={"/realestate-manager"}
        className="d-flex align-items-center justify-content-start gap-3 text-dark text-decoration-none pb-3 pt-5 rounded-1 px-4"
      >
        <FaTv className="text_maincolor" />{" "}
        <p className="mb-0 fs-14">RealEstate Orders</p>
      </Link>{" "}
      <Link
        to={"/retouching-manager"}
        className="d-flex align-items-center justify-content-start gap-3 text-dark text-decoration-none py-3 rounded-1 px-4"
      >
        <FaTv className="text_maincolor" />{" "}
        <p className="mb-0 fs-14">Retouching Orders</p>
      </Link>{" "}
      <Link
        to={"/colorcorrection-manager"}
        className="d-flex align-items-center justify-content-start gap-3 text-dark text-decoration-none py-3 rounded-1 px-4"
      >
        <FaTv className="text_maincolor" />
        <p className="mb-0 fs-14">ColorCorrection Orders</p>
      </Link>{" "}
      <Link
        to={"/culling-manager"}
        className="d-flex align-items-center justify-content-start gap-3 text-dark text-decoration-none py-3 rounded-1 px-4"
      >
        <FaTv className="text_maincolor" />{" "}
        <p className="mb-0 fs-14">Culling Orders</p>
      </Link>{" "}
      <Link
        to={"/videoediting-manager"}
        className="d-flex align-items-center justify-content-start gap-3 text-dark text-decoration-none py-3 rounded-1 px-4"
      >
        <FaTv className="text_maincolor" />{" "}
        <p className="mb-0 fs-14">Video Editing Orders</p>
      </Link>{" "}
      <Link
        to={"/weddingalbum-manager"}
        className="d-flex align-items-center justify-content-start gap-3 text-dark text-decoration-none py-3 rounded-1 px-4"
      >
        <FaTv className="text_maincolor" />{" "}
        <p className="mb-0 fs-14">Wedding Album Orders</p>
      </Link>{" "}
    </div>
  );
};

export default Sidebar;
